import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as AWS from 'aws-sdk';
import * as cloneDeep from 'lodash/cloneDeep';
import * as i1 from '@angular/common/http';

class HttpdataService {
    constructor(http) {
        this.http = http;
    }
    httpRequest(url, method, body, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                var response;
                if (!headers)
                    headers = { 'content-type': 'application/json' };
                switch (method) {
                    case 'GET':
                        response = yield this.http.get(url, { 'headers': headers }).toPromise();
                        return response;
                    case 'POST':
                        response = yield this.http.post(url, body, { 'headers': headers }).toPromise();
                        return response;
                    case 'PUT':
                        response = yield this.http.put(url, body, { 'headers': headers }).toPromise();
                        return response;
                }
            }
            catch (err) {
                console.error('Error in fetching data from: ' + url + ' -- ' + err.toString());
                return null;
            }
        });
    }
}
HttpdataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HttpdataService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
HttpdataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HttpdataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: HttpdataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class DynamoLibService {
    constructor(httpdataService) {
        this.httpdataService = httpdataService;
        this.servertimeurl = 'https://hjc7g4pb48.execute-api.ap-south-1.amazonaws.com/prod/a-getservertime'; // URL to web API
    }
    getServerTime() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.offset) {
                var resp = yield this.httpdataService.httpRequest(this.servertimeurl, 'POST', '{}');
                if (resp) {
                    this.offset = resp.body.servertime - new Date().getTime();
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
    getTime() {
        return new Date().getTime() + this.offset;
    }
    initializeCredsAndService(credentials, username, debugmode) {
        return __awaiter(this, void 0, void 0, function* () {
            this.congitnoaccess = true;
            this.credentials = credentials;
            this.debugmode = debugmode;
            this.loggedinusername = username;
            return yield this.getServerTime();
        });
    }
    initializeKeyAccess(username, debugmode, secretKeyId, secretAccessKey) {
        return __awaiter(this, void 0, void 0, function* () {
            this.congitnoaccess = false;
            this.debugmode = debugmode;
            this.loggedinusername = username;
            this.secretKeyId = secretKeyId;
            this.secretAccessKey = secretAccessKey;
            return yield this.getServerTime();
        });
    }
    connect() {
        if (this.congitnoaccess)
            this.dbClient = new AWS.DynamoDB.DocumentClient({ region: 'ap-south-1', credentials: this.credentials, convertEmptyValues: true });
        else
            this.connectWithKey();
    }
    connectWithKey() {
        /*var accessKeyid = 'AKIARPKP6CZJCLX7SUCB';
        var secretAccessKey = '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';

        if(this.secretKeyId && this.secretKeyId.length > 0){
            accessKeyid = this.secretKeyId;
            secretAccessKey = this.secretAccessKey;
        }*/
        AWS.config.accessKeyId = 'AKIA5VQR7V7YY75OEZ7H';
        AWS.config.secretAccessKey = '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';
        AWS.config.region = 'ap-south-1';
        this.dbClient = new AWS.DynamoDB.DocumentClient({ region: 'ap-south-1', convertEmptyValues: true });
    }
    connectWithKeyParams(accessKeyId, secretAccessKey) {
        AWS.config.accessKeyId = accessKeyId;
        AWS.config.secretAccessKey = secretAccessKey;
        AWS.config.region = 'ap-south-1';
        this.dbClient = new AWS.DynamoDB.DocumentClient({ region: 'ap-south-1', convertEmptyValues: true });
    }
    /**
     *
     * @param tablename
     * @param key - Primary key of item (Both partition and sort key if it is composite primary key)
     * @returns item or null
     */
    getItem(tablename, key) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.connect();
                var params = { TableName: tablename, Key: key };
                var retpromise = yield this.dbClient.get(params).promise();
                if (retpromise.$response.data) {
                    return retpromise.$response.data.Item;
                }
                else {
                    console.error('|DBGETERR| Table Name ' + tablename + ', Error: ' + retpromise.$response.error);
                    return null;
                }
            }
            catch (err) {
                console.error('|DBGETERR| Table Name ' + tablename + ', Error: ' + err);
                return null;
            }
        });
    }
    /**
     *
     * @param transactionitems
     * @returns true : If transaction succesful, else false
     */
    transactionWrite(transactionitems) {
        return __awaiter(this, void 0, void 0, function* () {
            var retpromise;
            try {
                this.connect();
                var params = { "TransactItems": transactionitems };
                console.log('TXN WRITE PARAMS ' + JSON.stringify(params));
                retpromise = yield this.dbClient.transactWrite(params).promise();
                if (retpromise.$response.data) {
                    return true;
                }
                else {
                    console.error(retpromise.$response.error);
                    return false;
                }
            }
            catch (err) {
                console.error(err);
                return false;
            }
        });
    }
    /**
     * This function performs series of operations in a transaction.
     * Each operation is sent as Transacitonitem class
     *
     * @param arrtxnitems This is an object of Transactionitem class
     * @returns  true / false
     */
    performTransaction(arrtxnitems) {
        return __awaiter(this, void 0, void 0, function* () {
            var retpromise;
            try {
                var transactionwriteitems = [];
                for (var txn of arrtxnitems) {
                    var item = txn.item;
                    var clonedItem = cloneDeep(item);
                    //clonedItem.updatedat = this.getTime();
                    //clonedItem.updatedby = this.loggedinusername;
                    var params;
                    switch (txn.dmltype) {
                        case 'edit':
                            /*var curversion = item.objectversion;
                            var conditionexpression = "objectversion = :version" ;
                            var attribparams= {":version" : curversion};
                            clonedItem.objectversion = curversion + 1;*/
                            params = { TableName: txn.tablename, Item: clonedItem, "ConditionExpression": conditionexpression,
                                "ExpressionAttributeValues": attribparams
                            };
                            break;
                        case 'create':
                            //clonedItem.createdat = this.getTime();
                            //clonedItem.createdby = this.loggedinusername;
                            clonedItem.objectversion = 1;
                            params = { TableName: txn.tablename, "ConditionExpression": txn.conditionexpression,
                                "ExpressionAttributeValues": txn.expressionattributvalues, Item: clonedItem };
                            break;
                        case 'delete':
                            clonedItem.isarchived = true;
                            var curversion = item.objectversion;
                            var conditionexpression = "objectversion = :version";
                            var attribparams = { ":version": curversion };
                            clonedItem.objectversion = curversion + 1;
                            params = { TableName: txn.tablename, Item: clonedItem, "ConditionExpression": conditionexpression,
                                "ExpressionAttributeValues": attribparams
                            };
                            break;
                    }
                    console.log('Adding txn item ' + JSON.stringify(params));
                    transactionwriteitems.push({ 'Put': params });
                }
                //this.connect();
                return yield this.transactionWrite(transactionwriteitems);
            }
            catch (err) {
                console.error(retpromise.$response.error);
                return false;
            }
        });
    }
    /**
     * @param tablename
     * @param item - Item to be updated
     * @returns
     */
    editItem(tablename, item) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                var clonedItem = cloneDeep(item);
                this.connect();
                var curversion = item.objectversion;
                var conditionexpression = "objectversion = :version";
                var attribparams = { ":version": curversion };
                clonedItem.objectversion = curversion + 1;
                //clonedItem._lastChangedAt = this.getTime();
                //clonedItem.updatedat = this.getTime();
                //clonedItem.updatedby = this.loggedinusername;
                //clonedItem.updatedat = 
                var params = { TableName: tablename, Item: clonedItem, "ConditionExpression": conditionexpression,
                    "ExpressionAttributeValues": attribparams
                };
                var retpromise = yield this.dbClient.put(params).promise();
                if (retpromise.$response.data) {
                    return clonedItem;
                }
                else {
                    console.error(retpromise.$response.error);
                    return null;
                }
            }
            catch (err) {
                console.error('|DYNAMODBSERVICE| EXCEPTION putting item in  :' + tablename + err);
                return null;
            }
        });
    }
    /**
     * @param tablename
     * @param item - Item to be updated
     * @returns
     */
    putItem(tablename, item, forcreate, fordelete, conditionexpression, expressionattributvalues) {
        return __awaiter(this, void 0, void 0, function* () {
            var retpromise;
            var params;
            var clonedItem = cloneDeep(item);
            //clonedItem.updatedat = this.getTime();
            //clonedItem._lastChangedAt = this.getTime();
            //clonedItem.updatedby = this.loggedinusername;
            if (forcreate) {
                //clonedItem.createdat = this.getTime();
                //clonedItem.createdby = this.loggedinusername;
                clonedItem.objectversion = 1;
            }
            if (fordelete) {
                clonedItem.isarchived = true;
            }
            params = {
                TableName: tablename,
                ConditionExpression: conditionexpression,
                ExpressionAttributeValues: expressionattributvalues,
                Item: clonedItem
            };
            try {
                this.connect();
                retpromise = yield this.dbClient.put(params).promise();
                if (retpromise.$response.data) {
                    return clonedItem;
                }
                else {
                    if (this.debugmode)
                        console.error('|DBPUTERR|Error while putting item ' + retpromise.$response.error);
                    return null;
                }
            }
            catch (err) {
                if (this.debugmode)
                    console.error('|DBPUTERR|Error while putting item ' + tablename + err);
                return null;
            }
        });
    }
    /**
     * @param tablename
     * @param filterexpression - Optional parameter for filter expression
     * @param expressionattributvalues - Optional parameter for attribute values
     * @returns Table data or null
     */
    scanTable(tablename, filterexpression, expressionattributvalues) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.connect();
                var items = [];
                var lastkey = null;
                while (true) {
                    var retpromise;
                    var params;
                    if (lastkey != null) {
                        params = { "TableName": tablename, "ExclusiveStartKey": lastkey };
                        if (filterexpression && filterexpression.length > 0) {
                            params = { "TableName": tablename, "FilterExpression": filterexpression,
                                "ExpressionAttributeValues": expressionattributvalues, "ExclusiveStartKey": lastkey };
                        }
                    }
                    else {
                        params = { "TableName": tablename };
                        if (filterexpression && filterexpression.length > 0) {
                            params = { "TableName": tablename, "FilterExpression": filterexpression, "ExpressionAttributeValues": expressionattributvalues };
                        }
                    }
                    retpromise = yield this.dbClient.scan(params).promise();
                    if (retpromise.$response.data) {
                        if (retpromise.$response.data.LastEvaluatedKey && retpromise.$response.data.LastEvaluatedKey != null) {
                            lastkey = retpromise.$response.data.LastEvaluatedKey;
                            items = items.concat(retpromise.$response.data.Items);
                        }
                        else {
                            items = items.concat(retpromise.$response.data.Items);
                            return items;
                        }
                    }
                    else {
                        if (this.debugmode)
                            console.error('|DBERR|Error fetching data from : ' + tablename + ':' + retpromise.$response.error);
                        return null;
                    }
                }
            }
            catch (err) {
                if (this.debugmode)
                    console.log('|DBERR|Error fetching data from  :' + tablename + ':' + err);
                //console.error('Error fetching data: ' + err); 
                return null;
            }
        });
    }
    /**
     * This funciton is for querying dynamodb
     *
     * The parameters not used, should be passed as null to this function
     *
     * @param TableName - Name of table to be queried
     * @param IndexName  - Name of index
     * @param KeyConditionExpression - Condition expression
     * @param FilterExpression - Filter expression Run @ DB Lebel
     * @param ProjectionExpression  - Attributes to be projected
     * @param ExpressionAttributeValues  - Values passed to Expressions above
     * @param ExpressionAttributeNames  - Attribute names passed in expression, this is applicable when column names are using keywords, like *status*
     * @param ExclusiveStartKey - Start reading from
     * @param Limit  - No of rows to be returned
     * @param ScanIndexForward - If to be queried in forward direction or reverse
     * @returns Resultset - Array of items
     */
    queryDB(TableName, IndexName, KeyConditionExpression, FilterExpression, ProjectionExpression, ExpressionAttributeValues, ExpressionAttributeNames, ExclusiveStartKey, Limit, ScanIndexForward, filterdeleted) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                var queryparams = this.getQueryObject(TableName, IndexName, KeyConditionExpression, FilterExpression, ProjectionExpression, ExpressionAttributeValues, ExpressionAttributeNames, ExclusiveStartKey, Limit, ScanIndexForward);
                this.connect();
                var items = [];
                var lastkey = null;
                while (true) {
                    var retpromise;
                    if (lastkey != null) {
                        queryparams.ExclusiveStartKey = lastkey;
                        retpromise = yield this.dbClient.query(queryparams).promise();
                    }
                    else {
                        retpromise = yield this.dbClient.query(queryparams).promise();
                    }
                    if (retpromise.$response.data) {
                        if (retpromise.$response.data.LastEvaluatedKey && retpromise.$response.data.LastEvaluatedKey != null) {
                            lastkey = retpromise.$response.data.LastEvaluatedKey;
                            items = items.concat(retpromise.$response.data.Items);
                        }
                        else {
                            items = items.concat(retpromise.$response.data.Items);
                            if (!filterdeleted)
                                return items;
                            else
                                return this.removeDeletedRows(items);
                        }
                    }
                    else {
                        console.error('|DBQUERYERR| ERror fetching data from  :' + queryparams.TableName + ' -- ' + retpromise.$response.error);
                        console.error(retpromise.$response.error);
                        return null;
                    }
                }
            }
            catch (err) {
                console.error('|DBQUERYERR| ERror fetching data from  :' + queryparams.TableName + ' -- ' + err);
                return null;
            }
        });
    }
    //Helper functions
    /**
     * Removes soft - deleted rows from array
     * @param items - Original array
     * @returns Array of items without deleted values
     */
    removeDeletedRows(items) {
        var retarr = [];
        for (var item of items) {
            if (!item.isarchived)
                retarr.push(item);
        }
        return retarr;
    }
    /**
     *
     * Creates an object which directly maps with dynamodb qurey command
     * @param TableName - Name of table to be queried
     * @param IndexName  - Name of index
     * @param KeyConditionExpression - Condition expression
     * @param FilterExpression - Filter expression Run @ DB Lebel
     * @param ProjectionExpression  - Attributes to be projected
     * @param ExpressionAttributeValues  - Values passed to Expressions above
     * @param ExpressionAttributeNames  - Attribute names passed in expression, this is applicable when column names are using keywords, like *status*
     * @param ExclusiveStartKey - Start reading from
     * @param Limit  - No of rows to be returned
     * @param ScanIndexForward - If to be queried in forward direction or reverse
     * @returns  Object which can be passed as parameter to dynamodb Query API
     */
    getQueryObject(TableName, IndexName, KeyConditionExpression, FilterExpression, ProjectionExpression, ExpressionAttributeValues, ExpressionAttributeNames, ExclusiveStartKey, Limit, ScanIndexForward) {
        var queryobj = {};
        queryobj.TableName = TableName;
        queryobj.IndexName = IndexName;
        queryobj.KeyConditionExpression = KeyConditionExpression;
        queryobj.FilterExpression = FilterExpression;
        queryobj.ProjectionExpression = ProjectionExpression;
        queryobj.ExpressionAttributeValues = ExpressionAttributeValues;
        queryobj.ExpressionAttributeNames = ExpressionAttributeNames;
        queryobj.ExclusiveStartKey = ExclusiveStartKey;
        queryobj.Limit = Limit;
        queryobj.ScanIndexForward = ScanIndexForward;
        return queryobj;
    }
}
DynamoLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibService, deps: [{ token: HttpdataService }], target: i0.ɵɵFactoryTarget.Injectable });
DynamoLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpdataService }]; } });

class DynamoLibComponent {
    constructor() { }
    ngOnInit() {
    }
}
DynamoLibComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DynamoLibComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: DynamoLibComponent, selector: "lib-dynamo-lib", ngImport: i0, template: `
    <p>
      dynamo-lib works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-dynamo-lib',
                    template: `
    <p>
      dynamo-lib works!
    </p>
  `,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

class DynamoLibModule {
}
DynamoLibModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DynamoLibModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibModule, declarations: [DynamoLibComponent], exports: [DynamoLibComponent] });
DynamoLibModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DynamoLibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DynamoLibComponent
                    ],
                    imports: [],
                    exports: [
                        DynamoLibComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of dynamo-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DynamoLibComponent, DynamoLibModule, DynamoLibService };
